module.exports = __webpack_public_path__ + "static/img/top.03b8eef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/mo/top.svg
// module id = iQvU
// module chunks = 10